import { createSelector } from 'reselect';
import { getState } from './state';
import { RoomFlags, InitializationStatus } from '../../types';

export const getRoomSlice = createSelector([getState], slice => {
  return slice.room;
});

export const getActiveRoomId = createSelector(getRoomSlice, state => {
  return state?.activeRoomId;
});

export const getJustClosedRoomId = createSelector(getRoomSlice, state => {
  return state?.justClosedRoomId;
});

export const getLastActiveRoom = createSelector(getRoomSlice, state => {
  return state?.prevActiveRoom;
});

export const getPresence = createSelector(
  state => getRoomSlice(state),
  (state, roomId) => roomId,
  (state, roomId) => state?.presence?.[roomId] ?? {}
);

export const getMarkAsReadQueue = createSelector(getRoomSlice, state => {
  return state?.markAsReadQueue;
});

export const getTypingText = createSelector(getRoomSlice, state => {
  return state?.typingText;
});

export const getSentMsgMarker = createSelector(getRoomSlice, state => {
  return state?.sentMarker ?? 0;
});

export const getFocusMessageRequest = createSelector(
  getRoomSlice,
  state => state.focusMessageRequest
);

export const getSendError = createSelector(
  getRoomSlice,
  state => state.sendError
);

export const getIsNewChat = createSelector(
  getRoomSlice,
  state => state.newChatActive
);

export const getIsMessageSending = createSelector(
  getRoomSlice,
  (state, room_id: string) => room_id,
  (state, room_id) => {
    return state.sendingMessages?.[room_id] || false;
  }
);

export const getActiveRoomItem = createSelector(
  getRoomSlice,
  state => state?.activeRoomItem
);

export const getIsShowingRoomParticipantsList = createSelector(
  getRoomSlice,
  state => state.isShowingRoomParticipantsList
);

export const getIsBanned = createSelector(
  getRoomSlice,
  (state, room_id: string) => room_id,
  (state, room_id) => {
    return state?.activeRoomItem?.dmUser?.isBanned || false;
  }
);

export const getIsInRequests = createSelector(
  getRoomSlice,
  state => !!((state.activeRoomItem?.roomMeta.flags ?? 0) & RoomFlags.request)
);

export const getRoomDmCardData = createSelector(
  getRoomSlice,
  roomItem =>
    roomItem?.dmCardData ?? {
      initStatus: InitializationStatus.Initializing,
      watcherCount: 0,
      deviationCount: 0,
    }
);

export const getIsReadyToFocusMessageBox = createSelector(
  getRoomSlice,
  state => state.isReadyToFocusMessageBox
);
